import { parseNumber, formatRupiah } from "@/lib/format";

// Sum of payments linked to a specific source item
export function paidAmount(payments, type, id) {
  return (payments || [])
    .filter((p) => p.source_type === type && p.source_id === id)
    .reduce((s, p) => s + parseNumber(p.nominal), 0);
}

export function num(v) { return parseNumber(v); }

// budget item paid status
export function budgetSisa(item, payments) {
  return num(item.nominal) - paidAmount(payments, "budget", item.id);
}
export function isLunas(item, payments) {
  return budgetSisa(item, payments) <= 0;
}

// seserahan / life-after-married bought status (fully covered by payments)
export function isBought(item, payments, type) {
  const price = num(item.harga ?? item.estimasi);
  if (price <= 0) return paidAmount(payments, type, item.id) > 0;
  return paidAmount(payments, type, item.id) >= price;
}

// Build list of unpaid payable items for the Pembayaran dropdown
export function payableOptions(data) {
  const payments = data.pembayaran || [];
  const opts = [];
  (data.budget || []).forEach((b) => {
    if (!isLunas(b, payments)) opts.push({ type: "budget", id: b.id, label: `[Budget] ${b.nama} — sisa ${formatRupiah(budgetSisa(b, payments))}`, name: b.nama, remaining: budgetSisa(b, payments) });
  });
  (data.seserahan || []).forEach((s) => {
    if (!isBought(s, payments, "seserahan")) opts.push({ type: "seserahan", id: s.id, label: `[Seserahan] ${s.kebutuhan} — ${formatRupiah(num(s.estimasi) - paidAmount(payments, "seserahan", s.id))}`, name: s.kebutuhan, remaining: num(s.estimasi) - paidAmount(payments, "seserahan", s.id) });
  });
  (data.life_after_married || []).forEach((l) => {
    if (!isBought(l, payments, "life_after_married")) opts.push({ type: "life_after_married", id: l.id, label: `[Life After] ${l.kebutuhan} — ${formatRupiah(num(l.harga) - paidAmount(payments, "life_after_married", l.id))}`, name: l.kebutuhan, remaining: num(l.harga) - paidAmount(payments, "life_after_married", l.id) });
  });
  return opts;
}
